import HomeContent from "$lib/data/generated/content/home/data.json";
import ArticlesContent from "$lib/data/generated/content/articles/data.json";
import ServicesContent from "$lib/data/generated/content/services/data.json";

import { uploads as HomeUploads } from "$lib/data/generated/uploads/home/uploads";
import { uploads as ArticlesUploads } from "$lib/data/generated/uploads/articles/uploads";
import { uploads as ServicesUploads } from "$lib/data/generated/uploads/services/uploads";

const content = {
	["home"]: HomeContent,
	["articles"]: ArticlesContent,
	["services"]: ServicesContent
};
const uploads = {
	...HomeUploads,
	...ArticlesUploads,
	...ServicesUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
